import React from 'react';
import { Box, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

/**
 * A field label with a trailing info-icon explainer tooltip (§4.15).
 * Extracted from the byte-identical local helpers in MetricSettingsDialog
 * and TargetForm — use this instead of hand-rolling label+icon rows.
 */
export default function LabelWithInfo({ label, tooltip }: { label: React.ReactNode; tooltip: string }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <span>{label}</span>
      <Tooltip title={tooltip} placement="top" enterDelay={400} enterNextDelay={200}>
        <InfoOutlinedIcon fontSize="small" sx={{ cursor: 'help' }} />
      </Tooltip>
    </Box>
  );
}
